import { create } from 'zustand';
import type { ConnectionStatus } from '@platform/contracts';

/** Minimal session fields for lobby/auth UI before a game store is registered. */
export interface PlatformFallbackState {
  connectionStatus: ConnectionStatus;
  balance: number;
  currency: string;
  deviceType: 'desktop' | 'mobile' | 'tablet';
  setConnectionStatus: (status: ConnectionStatus) => void;
  setBalance: (balance: number) => void;
  setCurrency: (currency: string) => void;
  setDeviceType: (deviceType: PlatformFallbackState['deviceType']) => void;
}

export const platformFallbackStore = create<PlatformFallbackState>(set => ({
  connectionStatus: 'idle',
  balance: 0,
  currency: 'USD',
  deviceType: 'desktop',
  setConnectionStatus: status => set({ connectionStatus: status }),
  setBalance: balance => set({ balance }),
  setCurrency: currency => set({ currency }),
  setDeviceType: deviceType => set({ deviceType }),
}));
